import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  selector: 'email-admin-deletion-scheduled-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './admin-deletion-scheduled.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class AdminDeletionScheduledTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<AdminDeletionScheduledTemplateData>;
}

export type AdminDeletionScheduledTemplateData = {
  title: string;
  p1_html: string;
  p2_html: string;
  button_text: string;
  button_link: string;
  footer: {
    text: string;
    label: string;
    href: string;
    target: string;
  };
};

export const AdminDeletionScheduledTemplateMocks: AdminDeletionScheduledTemplateData[] = [
  {
    title: 'Your account is scheduled to be deleted in 1 month',
    p1_html:
      'Your account <b>john.example@example.com</b> is not associated with a company account and will be deleted soon.',
    p2_html: '<b>Scheduled deletion date</b>: 23 Sep 2022',
    button_text: 'See plans',
    button_link: 'http://recruitee.com',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
